$(function() {

  if ($('.js-customerSidebarToggle').length > 0) {

    //ウインドウ読み込み時とリサイズ時に発動
    $(window).on('load resize', function() {

      // SPのとき
      if ($(window).width() < 750) {

        // sideのアコーディオン

        $('.js-customerSidebarToggle').on('click', function() {
          //console.log('click');
          if ($('#CustomerSidebar').hasClass('-open')) {
            // open -> close
            $('.js-customerSidebarContent').stop().slideUp(200);
            $('#CustomerSidebar').removeClass('-open');
            $('.CustomerSidebarGray').removeClass('-open');
          } else {
            // close -> open
            $('.js-customerSidebarContent').stop().slideDown(200);
            $('#CustomerSidebar').addClass('-open');
            $('.CustomerSidebarGray').addClass('-open');

          }
        });

        // pcのとき
      } else {
        $('.js-customerSidebarToggle').off('click');
      }

    });
  }
});
